import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ReportAuditService extends BaseService {
  protected constructor() {
    super('ReportAudit');
  }

  updateReportAuditDetails(type: string, key: string, status: string): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/UpdateReportAuditDetails`, { type, key, status });
  }

  /**
   * Sales Invoices bulk print: records every invoice in the batch in one call - an Invoice
   * document status row on each of its orders, and PENDING -> PRINTED (nothing else moves).
   */
  updateSalesInvoicesAudit(invoiceIds: string[], status: string): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/UpdateSalesInvoicesAudit`, { invoiceIds, status });
  }
}
